import Tooltip from "tooltip.js/dist/tooltip";

const tooltips = document.querySelectorAll('.js-tooltip');
Array.from(tooltips).forEach((tooltip) => {
    // eslint-disable-next-line
    const createdTooltip = new Tooltip(tooltip, {
        title: tooltip.innerHTML,
        trigger: 'hover',
        html: true,
        template: `<div	class="tooltip" role="tooltip">
        <div class="tooltip-inner"></div><div class="tooltip-content">${tooltip.dataset.tooltip}</div>
        </div>`,
    });
});
